import { RouteObject } from 'react-router-dom'
import { PageLoadingSupport } from '$components/common'
import { default as Connection } from '.'

export const connectionRoutes: RouteObject[] = [
  {
    path: '/connection/complete',
    element: (
      <PageLoadingSupport title="Complete connection">
        <Connection.Connection.Component />
      </PageLoadingSupport>
    ),
    loader: Connection.Connection.Loader,
  },
]
